import {Editor, Element, Range, Transforms, type LinkElement} from "slate";

/**
 * Removes a link element at the current selection.
 */
export const unwrapLinkNode = (editor: Editor) => {
    Transforms.unwrapNodes(editor, {
        match: (n) =>
            !Editor.isEditor(n) && Element.isElement(n) && n.type === "link",
    });
};

/**
 * Updates a link element at the current selection with the new URL.
 */
export const updateLinkNode = (editor: Editor, newURL: string) => {
    Transforms.setNodes(
        editor,
        {url: newURL},
        {
            match: (n) =>
                !Editor.isEditor(n) &&
                Element.isElement(n) &&
                n.type === "link",
        },
    );
};

/**
 * Creates a link element at the current selection with the given URL.
 */
export const wrapLinkNode = (editor: Editor, url: string) => {
    if (getLinkNode(editor)) {
        unwrapLinkNode(editor);
    }

    const {selection} = editor;
    const isCollapsed = selection && Range.isCollapsed(selection);
    const link = {
        type: "link",
        url,
        children: isCollapsed ? [{text: url}] : [],
    } as const;

    if (isCollapsed) {
        Transforms.insertNodes(editor, link);
    } else {
        Transforms.wrapNodes(editor, link, {split: true});
    }
};

/**
 * Gets the link element at the current selection, if any.
 */
export const getLinkNode = (editor: Editor): LinkElement | undefined => {
    const [match] = Editor.nodes<LinkElement>(editor, {
        match: (n) =>
            !Editor.isEditor(n) && Element.isElement(n) && n.type === "link",
    });

    if (match) {
        return match[0];
    }
};
